<p> Afstand is: {{ distance }} {{ getMessage()}}</p>

<p> current location: {{ latitude}} en {{ longitude}} {{ time}}</p>
